<template>
  <el-config-provider :locale="locale">
    <div class="ys_main">
      <div class="ys_box">
        <div class="ys_title">悦宝金服隐私保护办法</div>
        <div class="ys_content"><p>
          上海悦宝互联网金融信息服务股份有限公司（以下简称“我公司”“悦宝金服”）是专注于证券金融类信息服务的合法机构，注册地位于上海市黄浦区制造局路787号208A。悦宝金服高度重视您的隐私保护，在您浏览悦宝金服网站（https://www.yoribo.com）、悦宝金服程序，或使用我们的服务时，我们将通过悦宝金服隐私保护办法（以下简称“本办法”）告知您我们如何收集、使用、存储及共享您的个人信息，以及您如何访问、更新、控制和保护您的个人信息。本办法与您使用我们的服务关系紧密，希望您仔细阅读，做出您认为适当的选择。您使用或继续使用我们的服务，即意味着您同意我们按照本办法内容处理您的相关信息。</p>
          <p class="ys_h2">一、个人基本信息范围</p>
          <p>
            个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，不包括匿名化处理后的信息。根据《信息安全技术个人信息安全规范》，个人基本信息包括：</p>
          <p class="ys_h3">（一）个人基本资料</p>
          姓名、出生年月日、性别、民族、国籍、住址、个人电话号码、电子邮件地址。
          <p class="ys_h3">（二）个人身份信息</p>
          有效身份证件的种类、号码、签发机关和有效期限。
          <p class="ys_h3">（三）个人生物识别信息</p>
          面部识别特征、指纹信息。
          <p class="ys_h3">（四）网络身份标识信息</p>
          个人信息主体账号、IP地址。
          <p class="ys_h3">（五）个人教育工作信息</p>
          职业、学历。
          <p class="ys_h3">（六）个人财产信息</p>
          银行账户、鉴别信息、交易、委托、转账、消费记录、流水记录及虚拟财产信息等。
          <p class="ys_h3">（七）个人上网记录</p>
          网站浏览记录、软件使用记录、点击记录、收藏列表等。
          <p class="ys_h3">（八）个人常用设备信息</p>
          包括硬件序列号、设备MAC地址、软件列表、唯一设备识别码等。
          <p class="ys_h2">二、个人金融信息范围</p>
          <p>根据《个人金融信息保护技术规范》，个人金融信息包括：</p>
          <p class="ys_h3">（一）C1类别</p>
          供金融业机构内部使用的个人金融信息，包括个人账户开立时间、开户机构、基于账户信息产生的支付标记信息、C2和C3类别信息中未包含的其他个人金融信息。
          <p class="ys_h3">（二）C2类别</p>
          可识别特定个人金融信息主体身份与金融状况的个人金融信息以及用于金融产品与服务的关键信息，包括证件类识别标识与证件信息、手机号码、账户登录的用户名、用户鉴别辅助信息、个人财产信息、交易信息、满足监管需要的影像信息及其他能够识别出特定主体的信息。
          <p class="ys_h3">（三）C3类别</p>
          用户鉴别信息的登录密码、交易密码、用于用户鉴别的个人生物识别信息。
          <p class="ys_h2">三、敏感个人信息范围</p>
          <p>
            敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。根据《信息安全技术个人信息安全规范》所载的个人敏感信息包括：</p>
          <p class="ys_h3">（一）个人财产信息</p>
          银行账户、鉴别信息、交易记录、流水记录、虚拟资产及兑换记录。
          <p class="ys_h3">（二）个人生物识别信息</p>
          面部识别特征、指纹信息。
          <p class="ys_h3">（三）个人身份信息</p>
          有效身份证件的种类、号码、签发机关和有效期限。
          <p class="ys_h3">（四）其他信息</p>
          网站浏览记录、个人电话号码。
          <p class="ys_h2">四、悦宝金服采集信息范围</p>
          <p class="ys_h3">（一）个人基本信息</p>
          <p class="ys_h3">1、个人基本资料</p>
          姓名（非必须）、出生年月日（未采集）、性别（非必须）、民族（未采集）、国籍（未采集）、住址（未采集）、个人电话号码（采集，用于注册及登录）、电子邮件地址（采集，用于注册及登录）。
          <p class="ys_h3">2、个人身份信息</p>
          （均未采集）有效身份证件的种类、号码、签发机关和有效期限。
          <p class="ys_h3">3、个人生物识别信息</p>
          （均未采集）面部识别特征、指纹信息。
          <p class="ys_h3">4、网络身份标识信息</p>
          （均未采集）个人信息主体账号、IP地址。
          <p class="ys_h3">5、个人教育工作信息</p>
          （均未采集）职业、学历。
          <p class="ys_h3">6、个人财产信息</p>
          （均未采集）银行账户、鉴别信息、交易、委托、转账、消费记录、流水记录及虚拟财产信息等。
          <p class="ys_h3">7、个人上网记录</p>
          （均未采集）网站浏览记录、软件使用记录、点击记录、收藏列表等。
          <p class="ys_h3">8、个人常用设备信息</p>
          （均未采集）包括硬件序列号、设备MAC地址、软件列表、唯一设备识别码等。
          <p class="ys_h3">（二）个人金融信息范围</p>
          <p>根据《个人金融信息保护技术规范》，个人金融信息包括：</p>
          <p class="ys_h3">1、C1类别</p>
          （均未采集）供金融业机构内部使用的个人金融信息，包括个人账户开立时间、开户机构、基于账户信息产生的支付标记信息、C2和C3类别信息中未包含的其他个人金融信息。
          <p class="ys_h3">2、C2类别</p>
          （均未采集）可识别特定个人金融信息主体身份与金融状况的个人金融信息以及用于金融产品与服务的关键信息，包括证件类识别标识与证件信息、手机号码、账户登录的用户名、用户鉴别辅助信息、个人财产信息、交易信息、满足监管需要的影像信息及其他能够识别出特定主体的信息）。
          <p class="ys_h3">3、C3类别</p>
          用户鉴别信息的登录密码（采集，用于登录）、交易密码（采集，用于模拟交易）、用于用户鉴别的个人生物识别信息（未采集）。
          <p class="ys_h3">（三）敏感个人信息范围</p>
          <p>
            敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。根据《信息安全技术个人信息安全规范》，个人敏感信息包括：</p>
          <p class="ys_h3">1、个人财产信息</p>
          （均未采集）：银行账户、鉴别信息、交易记录、流水记录、虚拟资产及兑换记录。
          <p class="ys_h3">2、个人生物识别信息</p>
          （均未采集）：面部识别特征、指纹信息。
          <p class="ys_h3">3、个人身份信息</p>
          （均未采集）：有效身份证件的种类、号码、签发机关和有效期限。
          <p class="ys_h3">4、其他信息</p>
          网站浏览记录（未采集）；个人电话号码（采集，用于注册及登录）。
          <p class="ys_h2">五、实名用户与非实名用户管理</p>
          <p class="ys_h3">（一）实名用户、非实名用户范围</p>
          实名用户指在悦宝金服注册并完成实名认证（绑定银行卡完成身份鉴权）的用户；非实名用户指在悦宝金服注册但未完成实名认证（未绑定银行卡）的用户。
          <p class="ys_h3">（二）悦宝金服用户管理标准</p>
          悦宝金服目前仅包含非实名用户。
          <p class="ys_h3">（三）账户注册、登录等服务</p>
          <p>根据悦宝金服账户注册流程，非实名用户注册方法如下：</p>
          当您注册悦宝金服账户时，若仅为非实名用户，根据《中华人民共和国网络安全法》及《移动互联网应用程序信息服务管理规定》等实名制要求，您需要提供手机号码，以便生成通行证账户并正常使用我们的相关服务。享受服务如下：
          <p class="ys_h3">1、证券金融信息服务</p>
          可自主查看悦宝金服提供的证券金融类信息。
          <p class="ys_h3">2、账户登录</p>
          您登录悦宝金服账户后，我们会依据《中华人民共和国网络安全法》和《具有舆论属性或社会动员能力的互联网信息服务安全评估规定》，收集您使用账户服务时的悦宝金服软件版本号，并作为日志内容进行保存。
          <p class="ys_h3">3、模拟软件数据采集声明</p>
          您在悦宝金服可以下载使用模拟交易软件，请注意仅为模拟用途，非真实资金，我们会保存模拟委托、成交、持仓的相关记录。
          <p class="ys_h3">4、意见反馈</p>
          为便于妥善处理您的意见，我们会安排在线客服提供咨询帮助。为方便反馈答复，我们会记录您的手机号、电子邮箱、反馈内容和咨询内容。
          <p class="ys_h3">5、人脸识别鉴权</p>
          不提供。
          <p class="ys_h3">6、APP业务功能授权</p>
          暂未提供APP服务，因此不提供APP业务功能授权服务，这些服务包括通知权限、无线数据权限、相机权限、相册权限、麦克风权限、创建桌面快捷方式权限、存储权限、手机状态权限、请求安装包权限。
          <p class="ys_h2">六、关于Cookie等技术说明</p>
          为便于您获得更轻松的访问体验，省去重复输入注册信息的步骤，并判断您的账户是否处于安全状态，在您访问悦宝金服网站或使用悦宝金服提供的服务时，我们可能会通过以下小型数据文件识别您的身份，包括但不限于cookie、flashcookie或其他应用程序提供的本地存储。如果您想修改对cookie的接受程度或拒绝悦宝金服网站的cookie，您可以通过更改浏览器附加程序的设置，或访问提供商的网页来关闭或删除cookie。不过，这一操作在某些情况下可能会影响您安全访问悦宝金服网站及使用其提供的服务。
          <p class="ys_h2">七、信息存储标准</p>
          <p class="ys_h3">（一）存储地点</p>
          我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。若悦宝金服停止运营，我们将立即停止收集您的个人信息，并对所存储的所有个人信息进行删除或匿名化处理。
          <p class="ys_h3">（二）信息保护</p>
          我们收集您的信息后，将采取各种合理必要的保护措施。悦宝金服承诺将信息安全防护提升到合理水平，竭力避免信息出现被泄露、丢失、非授权使用、非授权披露、更改或损毁的风险。我们将运用必要的技术手段，包括但不限于SSL证书、信息加密存储、访问控制、最小授权管理等。
          <p class="ys_h2">八、个人信息保护投诉管理</p>
          您可以通过以下方式联系我们。我们承诺在15个工作日内对投诉进行答复：
          您可通过热线电话021-53099152与我们联系，客服会将相关事项转交给个人信息保护责任部门处理。
          <p class="ys_h2">九、安全事件应急处置</p>
          发生个人信息安全事件后，我们将按照法律法规要求，通过包括但不限于邮件、信函、电话或推送通知等方式，及时向您告知信息安全事件所涉信息的种类、原因等基本情况，以及影响范围、已采取或即将采取的措施、补救措施、自主防范降低风险的建议等内容。若因特殊情况难以逐一告知个人信息主体，我们会采取合理有效的方式发布公告。同时，我们会及时主动向上级管理部门上报信息安全事件的处置进度和状况。若您的合法权益受损，我们将承担相应的法律责任。
          请您务必清楚了解，悦宝金服不提供任何投资咨询服务、投资顾问服务及金融产品销售服务。您所使用的模拟交易软件，仅为模拟用途，不存在资金转账功能及服务。
          <p class="ys_h2">十、个人信息使用规范</p>
          我们会根据本隐私管理办法的约定，为实现产品或服务功能而使用所收集的个人信息。
          收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，不会对外提供这部分数据。这部分数据仅在悦宝金服内部进行统计、分析，形成特征标签，用于向您发送、提供与您相关的服务信息。如您不希望接收此类内容，您可通过回复短信退订。
          <p class="ys_h2">十一、个人信息特殊使用情况</p>
          <p>根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：</p>
          <p>（一）悦宝金服履行法律法规规定的义务相关的；</p>
          <p>（二）与国家安全、国防安全直接相关的；</p>
          <p>（三）与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>（四）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
          <p>（五）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
          <p>（六）您自行向社会公众公开的个人信息。</p>
          <p class="ys_h2">十二、个人信息管理</p>
          您可通过悦宝金服官方网站登录悦宝金服账户，在“账户管理”中查看账户信息，包括昵称、手机号、电子邮箱等信息，可以修改账户密码。
          悦宝金服的账户及密码仅用于网站浏览、模拟软件使用、购买账户服务升级用途。
          当您需要注销账户，可在“账户管理”中进行注销，您账户内的所有信息将被清空。
          <p class="ys_h2">十三、未成年人的信息保护</p>
          悦宝金服不对未成年人提供服务，即《中华人民共和国未成年人保护法》规定的未满十八周岁的公民。
          我们的网站和服务主要面向成年人，但若您为未成年人，我们将根据国家相关法律法规的规定对您的个人信息保密性及安全性进行特别保护。如果您为未成年人，您应当请监护人阅读本指引或在监护人的指导下阅读本指引，并在取得您的监护人同意的前提下向我们提供您的相关信息以便使用我们的相关服务。如您的监护人不同意您按照本指引使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
          如您为未成年人的监护人，当您对该未成年人的信息处理存在疑问时，请及时联系我们。
          <p class="ys_h2">十四、纠纷解决</p>
          本办法的成立、生效、履行、解释和争议解决适用中华人民共和国的法律（不包含港澳台地区法律），并排除一切冲突法规定的适用。如出现任何争议和纠纷，悦宝金服将与用户友好协商处理；协商不成时，悦宝金服和用户均同意将相关争议和纠纷交由上海仲裁委员会按照该会最新仲裁规则进行仲裁。仲裁裁决是终局的，对本协议双方当事人均有约束力。

        </div>


      </div>

    </div>


  </el-config-provider>
</template>
<script>

import zhCn from "element-plus/lib/locale/lang/zh-cn";


export default {
  components: {},
  data() {
    return {
      locale: zhCn,
    };
  },
  methods: {}
};

</script>

<style scoped>
.ys_main {
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.ys_box {
  padding: 50px 15%;
}

.ys_title {
  text-align: center;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 20px;
}

.ys_content {
  color: #040404;
  font-size: 14px;
  line-height: 24px;
  white-space: pre-wrap;
}

.ys_content p {
  margin: 8px 0 0 0;
}

.ys_h2 {
  margin: 18px 0 6px 0;
  font-weight: 600;
}

.ys_h3 {
  margin: 12px 0 4px 0;
  font-weight: 500;
}

.us_test {
  display: block;
  font-weight: 400;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 15px;
}


</style>
